/**
 * Formats a number as a currency string with the specified currency code.
 * @param amount The amount to format
 * @param currency The ISO 4217 currency code (defaults to USD)
 * @param options Additional formatting options
 * @returns A formatted currency string (e.g., "$1,234.56")
 */
export const formatCurrency = (
  amount: number,
  currency: string = "USD",
  options: {
    minimumFractionDigits?: number;
    maximumFractionDigits?: number;
  } = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
): string => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency.toUpperCase(),
    minimumFractionDigits: options.minimumFractionDigits,
    maximumFractionDigits: options.maximumFractionDigits,
  }).format(amount);
};

/**
 * `formatCurrency` without a zero cents part: "$120" for a whole amount,
 * "$45.50" otherwise, so a figure never rounds away from the one printed.
 */
export const formatCurrencyDroppingZeroCents = (
  amount: number,
  currency: string = "USD",
): string => {
  const digits = Number.isInteger(amount) ? 0 : 2;
  return formatCurrency(amount, currency, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
};
